import { z } from 'zod';
import * as FlatModels from '../../internal';

export const AvailableBlockSchema = z.object({
  id: z.string(),
  parentId: z.string(),
});

export type AvailableBlock = z.infer<typeof AvailableBlockSchema>;

export const AvailableSlideSchema = z.object({
  id: z.string(),
  page: z.string(),
  parentId: z.string(),
});

export type AvailableSlide = z.infer<typeof AvailableSlideSchema>;

export type TrainingResultType = IndicationQuestionResult | KPrimQuestionResult | MappingQuestionResult | SingleChoiceQuestionResult | FreetextQuestionResult;

const TrainingResultSchema = z.object({
  trainingId: z.string(),
  questionId: z.string(),
  required: z.boolean(),
  order: z.number(),
  showFeedback: z.boolean(),
  showExplanation: z.boolean(),
  total: z.number().optional(),
  empty: z.number().optional(),
  correct: z.number(),
  wrong: z.number(),
});

export const MappingQuestionResultSchema = TrainingResultSchema.extend({
  answer: z.array(z.string()).nullable().optional(),
});

export type MappingQuestionResult = z.infer<typeof MappingQuestionResultSchema>;

export const SingleChoiceQuestionResultSchema = TrainingResultSchema.extend({
  answer: z.number().nullable().optional(),
});

export type SingleChoiceQuestionResult = z.infer<typeof SingleChoiceQuestionResultSchema>;

export const KPrimQuestionResultSchema = TrainingResultSchema.extend({
  answer: z.array(z.string()).nullable().optional(),
});

export type KPrimQuestionResult = z.infer<typeof KPrimQuestionResultSchema>;

export const IndicationQuestionResultSchema = TrainingResultSchema.extend({
  answer: z.number().nullable().optional(),
});

export type IndicationQuestionResult = z.infer<typeof IndicationQuestionResultSchema>;

export const FreetextQuestionResultSchema = TrainingResultSchema.extend({
  answer: z.boolean().nullable().optional(),
  text: z.string().optional(),
});

export type FreetextQuestionResult = z.infer<typeof FreetextQuestionResultSchema>;

export const TrainingSharedSlideQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: FlatModels.NodeEntityModels.SlideNodeSchema,
  subjectId: z.string(),
});

export type TrainingSharedSlideQueryResult = z.infer<typeof TrainingSharedSlideQueryResultSchema>;

export const TrainingSharedBlockQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: FlatModels.NodeEntityModels.BlockNodeSchema,
  subjectId: z.string(),
});

export type TrainingSharedBlockQueryResult = z.infer<typeof TrainingSharedBlockQueryResultSchema>;


export type QuizStartDataItem = {
  id: string,
  parentId: string,
  position: number,
  page: FlatModels.PageEntityModels.PageEntityType,
  children: QuizStartDataItem[],
  expanded?: boolean,
  nodeIds?: string[]
}
